import type { DatapointConfidence, DiscoveredKind } from '@/services/discoveredDatapoints'

/** How a found datapoint reads on screen — kinds, confidence bands and a sample value. */

export const KINDS: DiscoveredKind[] = ['currency', 'percent', 'number', 'text', 'date']

/** How each band reads on screen, and what it means for who decides. `hover`
 *  is the chip's hover, when the chip opens something — as the deal and file
 *  chips beside it do, the same hue a step stronger. */
export const BAND: Record<DatapointConfidence['band'], { text: string; chip: string; hover: string; note: string }> = {
  auto: {
    text: 'text-emerald-300',
    chip: 'bg-emerald-500/10 text-emerald-300/90',
    hover: 'hover:bg-emerald-500/20',
    // A row still waiting here is waiting for a person: the engine only ever
    // teaches the parser a word for a field that exists.
    note: 'strong evidence — a new field is still a person’s decision to add',
  },
  review: {
    text: 'text-amber-300',
    chip: 'bg-amber-500/10 text-amber-300/90',
    hover: 'hover:bg-amber-500/20',
    note: 'worth your read — evidence is real but not conclusive',
  },
  weak: {
    text: 'text-stone-400',
    chip: 'bg-stone-500/10 text-stone-400',
    hover: 'hover:bg-stone-500/20',
    note: 'thin evidence — seen rarely, or the values do not hold together',
  },
}

export function formatSample(value: number | string | null): string {
  if (value === null || value === undefined) return '—'
  if (typeof value === 'number') {
    if (Math.abs(value) > 0 && Math.abs(value) < 1.5) return `${(value * 100).toFixed(2)}%`
    return value.toLocaleString()
  }
  return String(value)
}
